import script from "./adjustStock.vue?vue&type=script&setup=true&lang=js"
export * from "./adjustStock.vue?vue&type=script&setup=true&lang=js"

import "./adjustStock.vue?vue&type=style&index=0&id=748944ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-748944ec"]])

export default __exports__